export default "/fonts/vendor/primereact/resources/themes/lara-light-indigo/Inter-roman.var.woff2?ba4caefcdf5b36b438db92786991c845";